export const FUNCTION_DISABLED_ERROR_CODE = 3020
import i18n from '@/utils/i18n'

type GraphQlErrorLike = {
  graphQLErrors?: readonly {
    extensions?: Readonly<Record<string, unknown>> | null
  }[]
}

type GraphQlResponseErrorLike = {
  message?: unknown
  path?: readonly (string | number)[]
  extensions?: Readonly<Record<string, unknown>> | null
}

const DOMAIN_ERROR_CODE_MIN = 2000
const DOMAIN_ERROR_CODE_MAX = 3999
const SAFE_EXTENSION_KEYS = ['attemptsRemaining', 'retryAfterSeconds'] as const

export function getGraphQlErrorCode(error: GraphQlErrorLike): number | undefined {
  const value = error.graphQLErrors?.[0]?.extensions?.code
  const code = Number(value)

  return Number.isFinite(code) ? code : undefined
}

export function isFunctionDisabledError(error: GraphQlErrorLike): boolean {
  return getGraphQlErrorCode(error) === FUNCTION_DISABLED_ERROR_CODE
}

export function getTradingDisabledMessage() {
  return i18n.t('ui:tradingDisabled')
}

export function graphQlErrorLogDetails(operationName: string | undefined, errors: readonly GraphQlResponseErrorLike[]) {
  return {
    operation: operationName || 'anonymous',
    errors: errors.map((error) => {
      const details: Record<string, string | number> = {}
      const code = normalizeErrorCode(error.extensions?.code)
      if (code !== undefined) details.code = code
      if (error.path?.length) details.path = error.path.map(String).join('.')

      for (const key of SAFE_EXTENSION_KEYS) {
        const value = normalizeNonNegativeNumber(error.extensions?.[key])
        if (value !== undefined) details[key] = value
      }
      return details
    })
  }
}

export function areDomainGraphQlErrors(errors: readonly GraphQlResponseErrorLike[]) {
  return (
    errors.length > 0 &&
    errors.every((error) => {
      const code = normalizeErrorCode(error.extensions?.code)
      return code !== undefined && code >= DOMAIN_ERROR_CODE_MIN && code <= DOMAIN_ERROR_CODE_MAX
    })
  )
}

function normalizeErrorCode(value: unknown): number | undefined {
  const code = Number(value)
  return Number.isFinite(code) ? code : undefined
}

function normalizeNonNegativeNumber(value: unknown): number | undefined {
  const number = Number(value)
  return Number.isFinite(number) && number >= 0 ? number : undefined
}
